<script lang="ts" setup>
import { Heading, Text } from '~ds/components/ui/typography';

/**
 * An index page's title: the page name set beside its 3D illustration, the page's h1 at every size,
 * with an optional subtitle under the name.
 */
interface Props {
  title: string;
  illustrationSrc?: string;
  subtitle?: string;
}

withDefaults(defineProps<Props>(), { illustrationSrc: undefined, subtitle: undefined });
</script>

<template>
  <div
    class="flex items-center gap-3"
    data-testid="index-header"
  >
    <NuxtImg
      v-if="illustrationSrc"
      :src="illustrationSrc"
      alt=""
      role="presentation"
      width="80"
      height="80"
      fit="inside"
      class="size-15 shrink-0 object-contain md:size-20"
    />
    <div class="flex flex-col gap-2">
      <Heading as="h1" size="xl">
        {{ title }}
      </Heading>
      <Text
        v-if="subtitle"
        size="sm"
        data-testid="index-header-subtitle"
      >
        {{ subtitle }}
      </Text>
    </div>
  </div>
</template>
